import type { QuotationDocumentData } from '@/pages/quotation-design/types';

export default function QuotationHeader({ data }: { data: QuotationDocumentData }) {
  const {
    seller,
    title,
    documentNo,
    documentNoLabel,
    reference,
    referenceLabel,
    issueDate,
    validUntil,
  } = data;

  return (
    <div className="px-6 md:px-9 pt-7 md:pt-8">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
        {/* Left — Brand */}
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 md:w-11 md:h-11 bg-ink-700 flex items-center justify-center shrink-0">
            <i className="ri-box-3-line text-white text-lg md:text-xl" />
          </div>
          <div>
            <p className="text-lg md:text-xl font-bold tracking-tight text-ink-700 leading-none">
              {seller.companyName}
            </p>
            <p className="text-[11px] text-ink-400 mt-1.5 uppercase tracking-wider">
              {seller.tagline}
            </p>
          </div>
        </div>

        {/* Right — Document meta */}
        <div className="sm:text-right">
          <h2 className="text-base md:text-lg font-extrabold text-ink-700 tracking-wide">
            {title}
          </h2>
          <p className="text-sm font-mono text-ink-500 mt-1">
            {documentNoLabel && (
              <span className="font-sans text-ink-400">{documentNoLabel} </span>
            )}
            {documentNo}
          </p>
          {reference && (
            <p className="text-xs text-ink-400 mt-0.5">
              {referenceLabel || 'Reference'}:{' '}
              <span className="font-mono">{reference}</span>
            </p>
          )}
          <div className="mt-2.5 pt-2.5 border-t border-ink-100 space-y-1 text-xs">
            <div className="flex items-center justify-between gap-6 sm:justify-end sm:gap-3">
              <span className="text-ink-400">Date</span>
              <span className="font-medium text-ink-700">{issueDate}</span>
            </div>
            <div className="flex items-center justify-between gap-6 sm:justify-end sm:gap-3">
              <span className="text-ink-400">Valid Until</span>
              <span className="font-medium text-ink-700">{validUntil}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}